import { Box, Stack, Typography, useTheme } from "@mui/material";

interface ProductsHeaderProps {
    totalCount: number;
    title?: string;
    subtitle?: string;
}

const ProductsHeader = ({
    totalCount,
    title = "Product Hub",
    subtitle = "Your hub for orchestrating product-driven innovation."
}: ProductsHeaderProps) => {
    const theme = useTheme();

    return (
        <Stack spacing={0.75}>
            <Stack direction="row" alignItems="center" spacing={1.25}>
                <Typography
                    component="h1"
                    sx={{
                        fontSize: 22,
                        fontWeight: 600,
                        letterSpacing: "-0.012em",
                        color: theme.palette.text.primary,
                        lineHeight: 1.2
                    }}
                >
                    {title}
                </Typography>
                <Box
                    component="span"
                    sx={{
                        fontFamily: '"JetBrains Mono", monospace',
                        fontSize: 11,
                        color: theme.palette.text.secondary,
                        backgroundColor: theme.palette.grey[100],
                        px: 1,
                        py: 0.25,
                        borderRadius: 999,
                        lineHeight: 1.4
                    }}
                >
                    {totalCount} total
                </Box>
            </Stack>
            <Typography
                sx={{
                    fontSize: 13,
                    color: theme.palette.text.secondary
                }}
            >
                {subtitle}
            </Typography>
        </Stack>
    );
};

export default ProductsHeader;
